import React from 'react'

function Philosophy() {
  return (
    <>
    <section id="our-philosophy">
    <h1>Our Philosophy </h1>
    <p>We are proud to tell you that our philosophy is one of the most controversial and picked on standpoints in
        the brewing industry. Nevertheless, we at VPB insist that:</p>
    <div id="philosophy2">
        <p><span id="jumbo">"</span><span id="mobile-quote-fix">"</span>Beer with a lot of flavor is great! But it is also very filling. When you
            want to drink a lot of beers, at a friendly poker game for example, you should be free to do
            that, without feeling like you just ate a Thanksgiving dinner. Additionally, many people believe that
            what makes a beer great, is the absence of flavor.<span id="jumbo">"</span><span id="mobile-quote-fix">"</span></p>
    </div>

    <p>Beer brewers can choose to make lagers, or ales, or both. Many microbrewers focus on flavors. And the
        majority of small brewers produce ales. They often post blogs and rag on lagers or light beers. They
        make jokes like, "Why brew a beer like that, you can just piss in a cup and get the same thing." But on
        your next trip to the store you will see that the best selling beers are lagers. Here in Norway they
        stock pallets full of Tuborg and Carlsberg. In the US, despite all the shit talking about Bud Lite,
        Miller Lite, and Coors Light, these 3 beers occupy 65% of the shelves. Why? Because the majority of
        people just want a smooth beer that goes down easy.</p>
    <p>I love a good India Pale Ale, but what I prefer is a smooth lager. The dirty little secret, the reason
        many small brewers make ales, is that they don't have the equipment to ferment beer at 10 degrees
        celcius. At VPB, thanks to our old spare refrigerator, we can ferment lagers. And,we don't care if the
        process takes
        longer. </p>
</section>
    </>
  )
}

export default Philosophy